"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.testAll = exports.create = void 0;
var objs = [];
var create = function (key, click) {
    var c = {
        hotkey: key,
        onClick: click,
    };
    objs.push(c);
    return c;
};
exports.create = create;
var testAll = function (key) {
    var result = false;
    while (objs.length > 0) {
        var item = objs.pop();
        if (!item) {
            break;
        }
        if (item.hotkey === key) {
            item.onClick();
            result = true;
        }
    }
    return result;
};
exports.testAll = testAll;
